<template lang="pug">
	.tutorial-arrow-component(:class="{showed, 'elements-exist': elementsExist, [arrowPosition]: true}" v-pseudo-modal-name="'tutorial-arrow'")
		canvas(ref="canvas")
		.tutorial-arrow-wrapper(:style="{width: `${arrowWidth}px`, height: `${arrowHeight}px`, transform: `translate(${arrowLeft}px, ${arrowTop}px) scale(${arrowScale})`}")
		.tutorial-text-wrapper(:style="{width: `${textWidth}px`, transform: `translate(${textLeft}px, ${textTop}px) scale(${1})`}")
			.tutorial-text(v-if="step") {{step.text}}
				.button-wrapper(v-if="step.type === 'information'")
					button.btn.btn-warning(type="submit" v-on:click="completeStep($event)") Got it
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Tutorial } 		from './../../services/Tutorial'

	export default {
		name: "TutorialArrow",
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Tutorial Active Chapter Changed,Tutorial Active Chapter Step Changed,Tutorial Chapter Completed": function() {

					if (Tutorial.activeChapter && Tutorial.activeChapterStep) {
						if (!this.showed) this.show();
						else this.update();
					} else {
						this.hide();
					}

				}
			}
		},
		data() {

			this.Tutorial = Tutorial;

			this.step = null;

			this.canvasWidth = 100;
			this.canvasHeight = 100;

			this.arrowPosition = "left-top";
			this.arrowWidth = 100;
			this.arrowHeight = 100;
			this.arrowLeft = 0;
			this.arrowTop = 0;
			this.arrowScale = "1, 1";
			this.textWidth = 300;
			this.textLeft = 0;
			this.textTop = 0;

			return {
				showed: false,
				elementsExist: false // присутствуют ли нужные элементы на экране
			};

		},
		methods: {
			collectData() {

				console.log('TutorialArrow collectData');

				this.step = Tutorial.activeChapter ? Tutorial.activeChapterStep : null;

				if (this.step) {

					this.reposition();

				}

			},
			reposition() {

				if (!this.step) return;

				this.elementsExist = !!(document.querySelector(this.step.arrowElement) && document.querySelector(this.step.highlightElement));

				this.repositionArrow();
				this.repositionText();

				this.redrawCanvas();

			},
			repositionArrow() {

				let el = document.querySelector(this.step.arrowElement);
				if (!el) return console.warn('Can\'t show tutorial chapter step. Arrow element not found!', this.step);

				let rect = el.getBoundingClientRect();

				let arrowPosition = this.step.arrowPosition;

				if (arrowPosition === "auto") {

					let elCenterX = rect.left + rect.width / 2,
						elCenterY = rect.top + rect.height / 2,
						screenCenterX = window.innerWidth / 2,
						screenCenterY = window.innerHeight / 2;

					// console.log(arrowPosition, 'elCenterX', elCenterX, 'screenCenterX', screenCenterX);

					if (elCenterX > screenCenterX) {
						arrowPosition = (elCenterY > screenCenterY) ? "left-top" : "left-bottom";
					} else {
						arrowPosition = (elCenterY > screenCenterY) ? "right-top" : "right-bottom";
					}

				}

				// console.log('arrowPosition', arrowPosition, rect);

				this.arrowPosition = arrowPosition;

				if (arrowPosition === "left-top") {

					this.arrowLeft = rect.left - this.arrowWidth + this.step.arrowOffset[0];
					this.arrowTop = rect.top - this.arrowHeight + this.step.arrowOffset[1];
					this.arrowScale = "1, -1";

				} else if (arrowPosition === "left-bottom") {

					this.arrowLeft = rect.left - this.arrowWidth + this.step.arrowOffset[0];
					this.arrowTop = rect.top + rect.height + this.step.arrowOffset[1];
					this.arrowScale = "1, 1";

				} else if (arrowPosition === "right-top") {

					this.arrowLeft = rect.left + rect.width + this.step.arrowOffset[0];
					this.arrowTop = rect.top - this.arrowHeight + this.step.arrowOffset[1];
					this.arrowScale = "-1, -1";

				} else if (arrowPosition === "right-bottom") {

					this.arrowLeft = rect.left + rect.width + this.step.arrowOffset[0];
					this.arrowTop = rect.top + rect.height + this.step.arrowOffset[1];
					this.arrowScale = "-1, 1";

				} else if (arrowPosition === "left") {

					this.arrowLeft = rect.left - this.arrowWidth + this.step.arrowOffset[0];
					this.arrowTop = rect.top + rect.height / 2 + this.step.arrowOffset[1];
					this.arrowScale = "1, 1";

				} else if (arrowPosition === "right") {

					this.arrowLeft = rect.left + rect.width + this.step.arrowOffset[0];
					this.arrowTop = rect.top + rect.height / 2 + this.step.arrowOffset[1];
					this.arrowScale = "-1, 1";

				}

			},
			repositionText() {

				if (this.arrowPosition === "left-top") {

					this.textLeft = this.arrowLeft - this.textWidth / 2 + this.arrowWidth * 0.23;
					this.textTop = this.arrowTop;

				} else if (this.arrowPosition === "left-bottom") {

					this.textLeft = this.arrowLeft - this.textWidth / 2 + this.arrowWidth * 0.23;
					this.textTop = this.arrowTop + this.arrowHeight;

				} else if (this.arrowPosition === "right-top") {

					this.textLeft = this.arrowLeft + this.arrowWidth - this.textWidth / 2 - this.arrowWidth * 0.23;
					this.textTop = this.arrowTop;

				} else if (this.arrowPosition === "right-bottom") {

					this.textLeft = this.arrowLeft + this.arrowWidth - this.textWidth / 2 - this.arrowWidth * 0.23;
					this.textTop = this.arrowTop + this.arrowHeight;

				} else if (this.arrowPosition === "left") {

					this.textLeft = this.arrowLeft - this.textWidth / 2 + this.arrowWidth * 0.23;
					this.textTop = this.arrowTop + this.arrowHeight;

				} else if (this.arrowPosition === "right") {

					this.textLeft = this.arrowLeft - this.textWidth / 2 + this.arrowWidth * 0.23;
					this.textTop = this.arrowTop + this.arrowHeight;

				}

				if (this.step.textOffset) {

					this.textLeft += this.step.textOffset[0];
					this.textTop += this.step.textOffset[1];

				}

				if (this.textLeft < 20) this.textLeft = 20;
				if (this.textLeft + this.textWidth > window.innerWidth) this.textLeft = window.innerWidth - this.textWidth - 20;

			},
			redrawCanvas() {

				let canvas = this.$refs["canvas"];

				if (canvas) {

					let ctx = canvas.getContext('2d');

					if (this.canvasWidth !== window.innerWidth || this.canvasHeight !== window.innerHeight) {

						this.canvasWidth = window.innerWidth;
						this.canvasHeight = window.innerHeight;

						canvas.width = this.canvasWidth;
						canvas.height = this.canvasHeight;

					}

					//ctx.fillStyle = "#150f00";
					//ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

					ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

					let el = document.querySelector(this.step.highlightElement);
					if (!el) return console.warn('Can\'t show tutorial chapter step. Highlight element not found!', this.step);

					let rect = el.getBoundingClientRect();

					if (this.step.highlightType === "circle") {

						let radius = Math.max(rect.width, rect.height) / 2 * this.step.highlightScale;

						let g = ctx.createRadialGradient(rect.left + rect.width / 2, rect.top + rect.height / 2, 0, rect.left + rect.width / 2, rect.top + rect.height / 2, radius);
						g.addColorStop(1, "rgba(0,0,0,0)");
						g.addColorStop(0.9, "rgba(0,0,0,0.9)");
						g.addColorStop(0, "rgba(0,0,0,0.9)");

						ctx.fillStyle = g;
						ctx.fillRect(rect.left + rect.width / 2 - radius, rect.top + rect.height / 2 - radius, radius * 2, radius * 2);

						ctx.fillStyle = "rgba(0,0,0,0.9)";
						ctx.globalCompositeOperation = "xor";
						ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

					} else if (this.step.highlightType === "rectangle") {

						ctx.fillStyle = "rgba(0,0,0,0.9)";
						ctx.fillRect(rect.left - (rect.width * this.step.highlightScale[0] - rect.width) / 2, rect.top - (rect.height * this.step.highlightScale[1] - rect.height) / 2, rect.width * this.step.highlightScale[0], rect.height * this.step.highlightScale[1]);

						ctx.fillStyle = "rgba(0,0,0,0.9)";
						ctx.globalCompositeOperation = "xor";
						ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

					}

				}

			},
			completeStep() {

				Tutorial.completeStep();

			},
			close() {

				this.hide();

			}
		},
		mounted() {

			window.addEventListener("resize", () => {

				this.reposition();

			});

			clearInterval(this.repositionInterval);
			this.repositionInterval = setInterval(() => {

				if (this.showed && this.step) {

					//console.log('TUTORIAL REPOSITION');

					this.reposition();

					this.$forceUpdate();

				}

			}, 500);

		}
	}
</script>

<style lang="sass">

	.tutorial-arrow-component
		position: absolute
		z-index: 123000
		left: 0
		top: 0
		right: 0
		bottom: 0
		// background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.3s ease-in-out
		opacity: 0
		pointer-events: none

		canvas
			width: 100vw
			height: 100vh
			opacity: 0.8
			mix-blend-mode: multiply

		.tutorial-arrow-wrapper
			position: absolute
			width: 100px
			height: 100px
			left: 0
			top: 0
			opacity: 0
			transition: transform 0.3s ease-in-out, opacity 0.3s
			background: url("/tutorial/arrow.png") center / contain no-repeat
			//border: 1px solid red

		.tutorial-text-wrapper
			position: absolute
			width: 200px
			height: 0
			left: 0
			top: 0
			opacity: 0
			transition: transform 0.3s ease-in-out, opacity 0.3s
			text-align: center
			color: var(--warning)
			font-size: 20px

			.tutorial-text
				position: absolute
				left: 0
				top: 0
				width: 100%
				//border: 1px solid red

			.button-wrapper
				padding: 20px
				cursor: pointer

				button
					pointer-events: all
					text-transform: uppercase
					font-weight: bold
					color: #5a564d

	.tutorial-arrow-component.showed
		opacity: 1

		.tutorial-text
			animation: scale-down 0.5s ease-in-out
			animation-iteration-count: infinite

	.tutorial-arrow-component.hiding
		opacity: 0

	.tutorial-arrow-component.elements-exist

		.tutorial-arrow-wrapper
			opacity: 1

		.tutorial-text-wrapper
			opacity: 1

	.tutorial-arrow-component.left-top, .tutorial-arrow-component.right-top

		.tutorial-text
			top: auto
			bottom: 0

	@keyframes scale-down
		0%
			transform: scale(1.05)
		50%
			transform: scale(1)
		100%
			transform: scale(1.05)

</style>

